import { DistrictSelect } from '~/pages/district/components/district-select';
import { useUnsavedChangesGuard } from '~/hooks/useUnsavedChangesGuard';
import { schema, baseSchema, Schema } from './club-form.schema';
import { useAuthentication } from '~/hooks/useAuthentication';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '~/components/Button/Button';
import { placeholder } from '~/utils/placeholder';
import { Grid } from '~/components/Grid/Grid';
import { Input } from '~/components/Input';
import { Resolver, useForm } from 'react-hook-form';

interface Props {
  onSubmit: (data: Partial<Schema>) => void;
  mode: 'create' | 'edit';
  defaultValues?: Schema;
}

export function ClubForm({ defaultValues, mode, onSubmit }: Props) {
  const { isSuperUser } = useAuthentication();

  const { formState, register, handleSubmit } = useForm<Schema>({
    resolver: zodResolver(isSuperUser ? schema : baseSchema) as unknown as Resolver<Schema>,
    defaultValues: defaultValues ?? {},
  });

  const { dialog } = useUnsavedChangesGuard(formState);

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <Grid>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="name" label="Namn">
            <Input.Field type="text" {...register('name', { disabled: !isSuperUser })} formState={formState} />
          </Input.Group>
        </Grid.Item>

        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="email" label="E-post">
            <Input.Field type="text" {...register('email')} formState={formState} placeholder={placeholder.email} />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Grid>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="district" label="Distrikt">
            <DistrictSelect
              {...register('district', { disabled: !isSuperUser })}
              placeholder="Välj distrikt"
              defaultValue={defaultValues?.district}
              formState={formState}
            />
          </Input.Group>
        </Grid.Item>

        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="website" label="Hemsida">
            <Input.Field type="text" {...register('website')} formState={formState} placeholder={placeholder.website} />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Grid>
        <Grid.Item cols={{ sm: 12 }}>
          <Input.InlineGroup formState={formState} htmlFor="is_active" label="Aktiv">
            <Input.Checkbox {...register('is_active', { disabled: !isSuperUser })} formState={formState} />
          </Input.InlineGroup>
        </Grid.Item>
      </Grid>

      <Button.Group align="right">
        <Button type="submit">{{ create: 'Skapa', edit: 'Spara' }[mode]}</Button>
      </Button.Group>

      {dialog}
    </form>
  );
}
